<template>
  <div>
    <div class="r-text-intro">
      היי {{this.firstName}}, שמחים שחזרת!
    </div>
    <div class="r-text-headline-paragraph">
      <div>יש בעיה עם הפרטים.</div>
      <div>אנחנו על זה! ניצור איתך קשר.</div>
    </div>

    <div class="r-text-headline-paragraph">
      <div>בינתיים,</div>
      <div>בכל בקשה או שאלה -</div>
      <div>אפשר לפנות אלינו:</div>
      <link-button text="saving@riseup.co.il" @click="sendMailTo('saving@riseup.co.il')"/>
    </div>
  </div>
</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import { mapState } from 'vuex';
import ScrollToTop from '@/mixins/ScrollToTop';
import LinkButton from '@/components/base/LinkButton';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'FundSubmittedWithErrors',
  mixins: [TrackedPage, ScrollToTop, ExternalPagesActions],
  components: { LinkButton },
  computed: {
    ...mapState('meitavDash/openFund', ['firstName']),
  },
};
</script>
